/**
 * Utility functions
 */

/**
 * Get product by ID from MC_DATA
 */
export function getProductById(id) {
	if (!window.MC_DATA) return null;

	const numId = parseInt(id, 10);
	const product = window.MC_DATA.products.find(
		(p) => parseInt(p.id, 10) === numId
	);
	return product || null;
}

/**
 * Get current font family from select element
 */
export function getCurrentFontFamily() {
	const $sel = jQuery(".mc-font-family");
	return $sel.length
		? $sel.val() || "Merriweather Bold 700"
		: "Merriweather Bold 700";
}

/**
 * Preload fonts to ensure they're available
 */
export function preloadFonts(fonts) {
	const loadedFamilies = new Set();
	const supportsFontLoading =
		typeof document !== "undefined" &&
		document.fonts &&
		typeof document.fonts.load === "function";

	const loadPromises = [];

	fonts.forEach((f) => {
		const family = f.value;
		if (!family || loadedFamilies.has(family)) {
			return;
		}

		loadedFamilies.add(family);

		const span = document.createElement("span");
		span.textContent = "AaБбВв";
		span.style.position = "absolute";
		span.style.left = "-9999px";
		span.style.top = "-9999px";
		span.style.fontSize = "16px";
		span.style.fontFamily = family;
		document.body.appendChild(span);

		const cleanup = () => {
			if (span.parentNode) {
				span.parentNode.removeChild(span);
			}
		};

		if (supportsFontLoading) {
			const loadPromise = document.fonts
				.load(`normal 400 16px "${family}"`)
				.finally(() => {
					cleanup();
				});
			loadPromises.push(loadPromise);
		} else {
			loadPromises.push(
				new Promise((resolve) => {
					setTimeout(() => {
						cleanup();
						resolve();
					}, 2000);
				})
			);
		}
	});

	return loadPromises.length ? Promise.all(loadPromises) : Promise.resolve();
}

/**
 * Initialize font select dropdown
 */
export function initFontSelect(fonts) {
	const $select = jQuery(".mc-font-family");
	if (!$select.length) return;

	$select.empty();

	fonts.forEach((f) => {
		const $opt = jQuery("<option>")
			.val(f.value)
			.text(f.label)
			.attr("data-font", f.value);
		$select.append($opt);
	});

	$select.val(fonts[0].value);
}

/**
 * Check if current device is mobile
 */
export function isMobile() {
	return (
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent
		) || window.innerWidth <= 768
	);
}
